import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import BestafLogo from "@/pages/dashboard/misc/BestafLogo";
import { useForm } from "react-hook-form";
import {
  useForgotAdminPassword,
  useForgotUserPassword,
  useResendOTPAdmin,
  useResendOTPUser,
} from "../_misc/mutations";
import { useSearchParams } from "react-router-dom";

const ForgotPassword = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  const addSearchParam = (key: string, value: string) => {
    const params = new URLSearchParams(searchParam);
    params.set(key, value);
    setSearchParam(params);
  };
  const formType = searchParam.get("type");
  const status = searchParam.get("status");
  const email = searchParam.get("email");
  const form = useForm();

  const { mutate: forgotUserPassword, isPending: isPendingUser } =
    useForgotUserPassword({
      onSuccess: () => {
        addSearchParam("status", "success");
        addSearchParam("email", encodeURIComponent(form.getValues("email")));
      },
    });
  const { mutate: forgotAdminPassword, isPending: isPendingAdmin } =
    useForgotAdminPassword({
      onSuccess: () => {
        addSearchParam("status", "success");
        addSearchParam("email", encodeURIComponent(form.getValues("email")));
      },
    });
  const { mutate: resendOTPAdmin, } =
    useResendOTPAdmin({
      onSuccess: () => { },
    });
  const { mutate: resendOTPUser, } =
    useResendOTPUser({
      onSuccess: () => { },
    });

  const onSubmitResendOTP = (data: any) => {
    const resendData = {
      ...data,
      email: data.email.toLowerCase(),
    };

    if (formType === "admin") {
      resendOTPAdmin(resendData);
    } else {
      resendOTPUser(resendData);
    }
  };

  const onSubmit = (data: any) => {
    const forgotData = {
      ...data,
      email: data.email.toLowerCase(),
    };

    if (formType === "admin") {
      forgotAdminPassword(forgotData);
    } else {
      forgotUserPassword(forgotData);
    }
  };

  return (
    <div className="flex justify-center items-center h-screen">
      <div>
        <BestafLogo />

        <Card>
          <CardContent className="p-4">
            {status === "success" ? (
              <div className="flex flex-col justify-center items-center">
                <h1 className="text-2xl">Password Reset Successfully</h1>
                <p className="mt-4 text-lg">
                  We've sent an email to{" "}
                  <span className="text-primary font-semibold">
                    {form.getValues("email") || email}
                  </span>{" "}
                  with instructions on how to reset your password
                </p>
                <p>
                  If you don't receive the email,{" "}
                  <Button
                    type="button"
                    variant={"link"}
                    className="bg-primary-100 w-full h-12 py-2 mt-4"
                    onClick={() =>
                      onSubmitResendOTP(form.getValues("email") || email)
                    }
                  >
                    Resend Email
                  </Button>
                </p>
              </div>
            ) : (
              <>
                <div className="flex flex-col justify-center items-center">
                  <h1 className="text-2xl">Forgot Password?</h1>
                  <p className="mt-2">Enter your email to reset password</p>
                </div>

                <div className=" !text-[#333333] w-[500px]">
                  <Form {...form}>
                    <form
                      onSubmit={form.handleSubmit(onSubmit)}
                      className="space-y-4 mt-4"
                    >
                      <FormField
                        control={form.control}
                        name="email"
                        render={({ field }) => (
                          <FormItem>
                            <FormLabel>Email</FormLabel>
                            <FormControl>
                              <Input
                                type="email"
                                placeholder="Enter Email"
                                {...field}
                                className="h-12"
                              />
                            </FormControl>
                            <FormMessage />
                          </FormItem>
                        )}
                      />

                      <Button
                        disabled={isPendingAdmin || isPendingUser}
                        isLoading={isPendingAdmin || isPendingUser}
                        type="submit"
                        className="bg-primary-500 w-full h-12 py-2"
                      >
                        Submit
                      </Button>
                    </form>
                  </Form>
                </div>
              </>
            )}{" "}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ForgotPassword;
